import { Point } from './utils';
import {DoorType} from "./door";
import {WizartRoom} from "../services/wizart/wizart.service";

export enum LightPosition {
  CENTER = 'CENTER',
  LEFT_1 = 'LEFT_1',
  LEFT_2 = 'LEFT_2',
  RIGHT_1 = 'RIGHT_1',
  RIGHT_2 = 'RIGHT_2'
}

export interface Location {
  x: number;
  y: number;
}

export interface LightSource {
  location: Location;
  intensity: number;
}

export enum ScenarioType {
  USER = 'USER',
  EXAMPLE = 'EXAMPLE'
}

export interface ClippedCorners {
  hasClippedCorners?: boolean;
  topLeftBottom?: Point;
  topLeftRight?: Point;
  topRightBottom?: Point;
  topRightLeft?: Point;
}

export interface Corners {
  topLeft: Point;
  topRight: Point;
  bottomRight: Point;
  bottomLeft: Point;
}

export type DoorCorners = Corners & ClippedCorners & {
  index: number;
  doorType: DoorType;
}

export interface ScenarioImageCustomData {
  wizartRoom?: WizartRoom;
  clippedDoorCorners?: Array<DoorCorners>;
}

export interface ScenarioImage {
  id: string;
  shortId: string;
  image: {
    url?: string
    base64?: string
  }
  shadowImage?: {
    url: string
  }
  thumbnailUrl: string;
  lightPosition: LightPosition
  doorType: DoorType,
  corners: Array<DoorCorners>
  isWaitingForVisualizationImprovement?: boolean
  type: ScenarioType
  lightSources: Array<LightSource>
  wizartRoom?: WizartRoom
}

export type Orientation = 'HORIZONTAL' | 'VERTICAL';
